import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";

const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Core.surface.inverse};
  border-bottom: 1px solid ${Core.border.muted};
  height: 70px;
`;

export const AccountSettingsBanner: React.FC = () => (
  <Wrapper>
    <Typography align="center" variant="pageHeaderSerifRegular">
      <StrictLocalMsg
        defaultMessage="Settings"
        description={{
          text: "Title informing the retailer that this is the account settings page",
        }}
      />
    </Typography>
  </Wrapper>
);
